function compareBagsCarousel() {
  document.querySelectorAll('.compare-bags-carousel').forEach(function (element) {
    var outer = element.closest('.compare-bags-carousel-outer');
    var nextButton = outer.querySelector('.swiper-button-next');
    var prevButton = outer.querySelector('.swiper-button-prev');
    var pagination = outer.querySelector('.compare-bags-pagination');

    if (element.swiper) element.swiper.destroy(true, true);

    function toggleControls(swiper) {
      var fitsOnScreen = swiper.isBeginning && swiper.isEnd;
      [nextButton, prevButton, pagination].forEach(function (control) {
        if (control) control.classList.toggle('hide-arrows', fitsOnScreen);
      });
    }

    new Swiper(element, {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 8,
      allowTouchMove: true,
      watchOverflow: true,
      pagination: { el: pagination.querySelector('.swiper-pagination'), type: 'progressbar' },
      navigation: { nextEl: nextButton, prevEl: prevButton },
      on: {
        init: toggleControls,
        resize: toggleControls
      }
    });
  });
}

function compareBagsArrowCenter() {
  document.querySelectorAll('.compare-bags-carousel-outer').forEach(function (outer) {
    var media = outer.querySelector('.compare-bags-card-media');
    if (!media) return;

    function center() {
      var top = media.offsetHeight / 2 - 25;
      outer.querySelectorAll('.swiper-button').forEach(function (button) {
        button.style.top = top + 'px';
      });
    }

    center();
    // the card image settles after fonts and swiper have done their work, so follow its height
    if (window.ResizeObserver && outer.dataset.cbObserved !== 'true') {
      outer.dataset.cbObserved = 'true';
      new ResizeObserver(center).observe(media);
    }
  });
}

compareBagsCarousel();
addEventListener('DOMContentLoaded', compareBagsArrowCenter);
addEventListener('resize', compareBagsArrowCenter);
addEventListener('load', compareBagsArrowCenter);
document.addEventListener('shopify:section:load', function () {
  compareBagsCarousel();
  compareBagsArrowCenter();
});
